import OpenReplay from '@openreplay/tracker';
import React, { Suspense, useEffect, useState } from 'react';
import { useT } from '../../i18n/LanguageProvider';
import LanguageSwitcher from '../../i18n/LanguageSwitcher';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import CustomLoader from '../../components/CustomLoader';
import NewHeader from '../../components/NewHeader';
import { ROUTE_NAMES } from '../../Routes/routeNames';
import { user_plan_services } from '../../services/request/userPlan';
import { UserPlanInterface } from '../../services/request/userPlan.interface';
import NewModal from '../../components/NewModal';
import SelectTemplate from './Dashboards/Components/SelectTemplate';
import useSvg from '../../utils/useSvg';
import { Crisp } from 'crisp-sdk-web';
import ChatBox from '../../components/ChatBox';
import VideoLtdBanner from '../../components/VideoLtdBanner';
import AccessBlockedModal from '../../components/AccessBlockedModal';
import { workspace_custom_domain_services } from '../../services/request/workspaceCustomDomain';
import { setWorkspaceDomain, clearWorkspaceDomain } from '../../redux/actions/workspaceDomainActions';
// import ContactsEngagementsList from './ContactsEngagementList';
// import AvatarImage from '../../assets/images/kate.jpg';
export const tracker = new OpenReplay({
	projectKey: 'GJKBWrfNUq34UHYYIsTf',
	ingestPoint: 'https://openreplay.cardclan.io/ingest',
});
const svgPath = '<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />';
declare const window: any;
const LoggedInLayout: React.FC = () => {
	const { t } = useT();
	const { pathname } = useLocation();
	const closeIcon = useSvg('http://www.w3.org/2000/svg', '0 0 24 24', 'white', '#808080', svgPath);
	const whiteLabelSettings = useSelector((state: any) => state.whiteLabelSettings);
	const userPlan = useSelector((state: any) => state.userPlan);
	const userProfile = useSelector((state: any) => state.userProfile);
	const [hover, setHover] = useState(false);
	const [selectTemplate, setSelectTemplate] = useState(false);
	const [expiryBanner, setExpiryBanner] = useState(true);
	const [hoverIndex, sethoverIndex] = useState<number>(0);
	const [checkUserPlan, setUserPlan] = useState<UserPlanInterface>();

	const isCompanyNameAvailable = () => {
		if (userProfile.Company) {
			return userProfile.Company;
		} else if (userProfile.email) {
			const result = userProfile.email.split('@')[1];
			let domains = [
				'yahoo.com',
				'gmail.com',
				'google.com',
				'hotmail.com',
				'me.com',
				'aol.com',
				'mac.com',
				'live.com',
				'comcast.com',
				'googlemail.com',
				'msn.com',
				'hotmail.co.uk',
				'yahoo.co.uk',
				'facebook.com',
				'verizon.net',
				'att.net',
				'gmz.com',
				'mail.com',
				'outlook.com',
				'mailinator.com',
			];
			const check = domains.includes(result);
			if (check) {
				return userProfile.email.split('@')[0];
			} else {
				return result;
			}
		}
	};

	const companyName = isCompanyNameAvailable();
	useEffect(() => {
		if (!!userProfile) {
			// Get user plan - This is where subscription status is checked on app load
			// The getUserPlan API call determines if user has active subscription
			user_plan_services
				.getUserPlan(userProfile?._id)
				.then((data) => {
					if (data) {
						// user plan exists - subscription is active
						setUserPlan(data);
					}
				})
				.catch((error) => {
					console.log({ error });
				});
		}
	}, [userProfile]);
	const handleClick = () => {
		setSelectTemplate(true);
	};
	const handleClose = () => {
		setSelectTemplate(false);
	};
	let navigate = useNavigate();
	const handleUpgradePlan = () => {
		navigate(ROUTE_NAMES.billing);
	};
	const navBarList = [
		{
			title: 'Dashboard',
			titleKey: 'nav.dashboard',
			path: ROUTE_NAMES.dashboard,
			iconLink: (c: string) => (
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="my-2">
					<path
						d="M1 10L3 8M3 8L10 1L17 8M3 8V18C3 18.5523 3.44772 19 4 19H7M17 8L19 10M17 8V18C17 18.5523 16.5523 19 16 19H13M7 19C7.55228 19 8 18.5523 8 18V14C8 13.4477 8.44772 13 9 13H11C11.5523 13 12 13.4477 12 14V18C12 18.5523 12.4477 19 13 19M7 19H13"
						stroke={c}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
		{
			title: 'Cards',
			titleKey: 'nav.cards',
			path: ROUTE_NAMES.mycards,
			iconLink: (c: string) => (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="my-2">
					<path
						d="M4 16L8.58579 11.4142C9.36683 10.6332 10.6332 10.6332 11.4142 11.4142L16 16M14 14L15.5858 12.4142C16.3668 11.6332 17.6332 11.6332 18.4142 12.4142L20 14M14 8H14.01M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z"
						stroke={c}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
		{
			title: 'Video Cards',
			titleKey: 'nav.videoCards',
			path: ROUTE_NAMES.videoCards,
			iconLink: (c: string) => (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="my-2">
					<path
						d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
						stroke={c}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
		{
			title: 'Engagement',
			titleKey: 'nav.engagement',
			path: ROUTE_NAMES.engagement,
			iconLink: (c: string) => (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="my-2">
					<path
						d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
						stroke={c}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},

		{
			title: 'Settings',
			titleKey: 'nav.settings',
			path: ROUTE_NAMES.settings,
			iconLink: (c: string) => (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="my-2">
					<path
						d="M10.3246 4.31731C10.751 2.5609 13.249 2.5609 13.6754 4.31731C13.9508 5.45193 15.2507 5.99038 16.2478 5.38285C17.7913 4.44239 19.5576 6.2087 18.6172 7.75218C18.0096 8.74925 18.5481 10.0492 19.6827 10.3246C21.4391 10.751 21.4391 13.249 19.6827 13.6754C18.5481 13.9508 18.0096 15.2507 18.6172 16.2478C19.5576 17.7913 17.7913 19.5576 16.2478 18.6172C15.2507 18.0096 13.9508 18.5481 13.6754 19.6827C13.249 21.4391 10.751 21.4391 10.3246 19.6827C10.0492 18.5481 8.74926 18.0096 7.75219 18.6172C6.2087 19.5576 4.44239 17.7913 5.38285 16.2478C5.99038 15.2507 5.45193 13.9508 4.31731 13.6754C2.5609 13.249 2.5609 10.751 4.31731 10.3246C5.45193 10.0492 5.99037 8.74926 5.38285 7.75218C4.44239 6.2087 6.2087 4.44239 7.75219 5.38285C8.74926 5.99037 10.0492 5.45193 10.3246 4.31731Z"
						stroke={c}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
						stroke={c}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
	];

	const email = userProfile?.email;
	const uid = userProfile?._id;
	const currentWorkspace = useSelector((state: any) => state.currentWorkspace);
	const isVideoCardsEnabled = currentWorkspace?.videoCardsEnabled !== false;
	const dispatch = useDispatch();
	//const workspaceOwnerId = currentWorkspace?.owner_id
	tracker.setUserID(email || uid || 'No userID for this User');
	tracker.setMetadata('Current Workspace', currentWorkspace?._id);
	tracker.setMetadata('Current Plan', userPlan?._id);

	const name = useSelector((state: any) => {
		let { firstName, lastName } = state?.userProfile;
		let name = firstName && firstName !== '-' ? firstName : '';
		name = name + ' ' + (lastName && lastName !== '-' ? lastName : '');
		return String(name).trim().length ? name : null;
	});
	// only start tracker on production
	if (process.env.NODE_ENV === 'production') {
		tracker.start();
		if (!whiteLabelSettings) {
			if (process.env.NODE_ENV === 'production' && window.hyperengage) {
				window.hyperengage('identify_account', {
					account_id: currentWorkspace?._id,
					traits: {
						name: currentWorkspace?.name,
						is_trial: userPlan?.subscriptionType === 'trial' ? true : false,
						plan_name: userPlan?.plan_data?.plan_id,
						created_at: currentWorkspace?.createdAt,
						trial_start_date: currentWorkspace?.createdAt,
						company_name: companyName,
					},
				});
				window.hyperengage('identify_user', {
					user_id: uid,
					traits: {
						name: name,
						first_name: userProfile?.firstName,
						last_name: userProfile?.lastName,
						email: userProfile?.email,
						created_at: userProfile?.createdAt,
					},
				});
				if (window.analytics) {
					window.analytics.group(currentWorkspace?._id, {
						name: currentWorkspace?.name,
						is_trial: userPlan?.subscriptionType === 'trial' ? true : false,
						plan: userPlan?.plan_data?.plan_id,
						createdAt: currentWorkspace?.createdAt,
						trial_start_date: currentWorkspace?.createdAt,
						company_name: companyName,
					});
				}
			}
		}
	}

	const isWhiteLabeled =
		whiteLabelSettings?.domain === window.location.hostname &&
		whiteLabelSettings?.connectionStatus &&
		whiteLabelSettings?.sslStatus;

	const handleHover = (index: number) => {
		sethoverIndex(index);
		setHover(true);
	};
	const handleHoverClear = () => {
		setHover(false);
	};

	const defaultStyle = { minHeight: '100vh', backgroundColor: '#113190' };
	const whiteLabelStyle = {
		minHeight: '100vh',
		backgroundColor: whiteLabelSettings?.brandColors?.['Sidebar Color'],
	};
	const sideBarLogo = whiteLabelSettings?.logo?.['Dark Logo'];

	useEffect(() => {
		Crisp.user.setEmail(email);
		Crisp.user.setNickname(name);

		Crisp.session.setData({
			user_id: uid,
			email: email,
			plan: userPlan?.plan_id,
		});
	}, [name, email, uid, userPlan]);

	// Fetch workspace custom domain on workspace switch
	useEffect(() => {
		if (currentWorkspace?._id) {
			workspace_custom_domain_services
				.getWorkspaceDomain(currentWorkspace._id)
				.then((res: any) => dispatch(setWorkspaceDomain(res?.data || null)))
				.catch(() => dispatch(clearWorkspaceDomain()));
		}
	}, [currentWorkspace?._id, dispatch]);

	// Check if user's plan is disabled - if so, show blocking modal
	const isAccessBlocked = checkUserPlan?.disabled === true;
	// Server-side validation: Block all API calls when user is disabled
	useEffect(() => {
		if (isAccessBlocked) {
			// Override all API calls to prevent functionality
			const originalFetch = window.fetch;
			window.fetch = async () => {
				console.warn('API call blocked: User access is disabled');
				throw new Error('Access denied: Account is disabled');
			};

			// Cleanup on unmount
			return () => {
				window.fetch = originalFetch;
			};
		}
		return;
	}, [isAccessBlocked]);

	return (
		<>
			{/* Access Blocked Modal - renders on top of everything when plan is disabled */}
			<AccessBlockedModal isOpen={isAccessBlocked} />

			{!isWhiteLabeled && (
				<Helmet
					script={[
						{
							type: 'text/javascript',
						},
					]}
				>
					<script defer>
						{process.env.NODE_ENV === 'production' && uid && email
							? `
              <!-- Segment Identify -->
                analytics.identify('${uid}', {
                  ${name ? `name: '${name}',` : ''}
                  email: '${email}',
                  'Plan Name': '${userPlan?.plan_id}'
                });
                <!-- Segment Identify End -->
            `
							: ''}
					</script>
				</Helmet>
			)}
			{!isWhiteLabeled && (
				<Helmet
					script={[
						{
							type: 'text/javascript',
						},
					]}
				>
					<script defer>
						{process.env.NODE_ENV === 'production' && uid && email
							? `
                <!-- Group Identify -->
                  analytics.group(${currentWorkspace?._id}, {
                    name: ${name},
                    companyName: ${companyName},
                    planName: ${userPlan?.plan_id},
                    isTrial: ${userPlan?.trialUsed},
                    planType: ${userPlan?.subscriptionType}
                  });              
                  <!-- Group Identify End-->
            `
							: ''}
					</script>
				</Helmet>
			)}
			{/* {!isWhiteLabeled && (
        <Helmet
          script={[
            {
              type: 'text/javascript',
            },
          ]}
        >
          <script defer>
            {process.env.NODE_ENV === 'production' && uid && email
              ? `
              <!-- User Identify Start -->
              Beacon('identify', {
                name: '${name}',
                email: '${email}',
                userid: '${uid}',
              })
              <!-- User Identify End -->
            `
              : ''}
          </script>
        </Helmet>
      )} */}
			{!isWhiteLabeled && <ChatBox />}
			<div className="flex flex-row font-inter relative bg-bgGray gap-x-8">
				<div
					className={'hidden  pt-5 gap-y-8 max-w-112  fixed  md:block h-full'}
					style={isWhiteLabeled ? whiteLabelStyle : defaultStyle}
				>
					<div className="w-full pb-8 flex flex-col items-center justify-between h-full   ">
						<div className="w-full flex flex-col ">
							<div className="flex justify-center w-14   items-center  rounded-full mx-auto">
								<img
									className="md:h-12  h-8 pl-1 md:pt-0 "
									alt="cclan"
									src={isWhiteLabeled ? sideBarLogo : 'https://s3.us-east-2.amazonaws.com/cardclan.io-assets/cclan.png'}
								/>
							</div>
							<div className="flex-1 mt-8 w-full px-3 space-y-1.5">
								{navBarList.filter((item) => item.title !== 'Video Cards' || isVideoCardsEnabled).map((item, index) => (
									<Suspense fallback={<CustomLoader />} key={item.title}>
										<NavLink
											onMouseOver={() => handleHover(index)}
											onMouseLeave={handleHoverClear}
											to={item.path}
											className={({ isActive }) =>
												isActive
													? 'bg-white/15 ring-1 ring-white/10 shadow-sm flex px-2 py-2.5 rounded-xl flex-col group items-center justify-center text-white w-full transition-all duration-150'
													: 'flex py-2.5 px-2 text-white/60 hover:bg-white/10 hover:text-white rounded-xl flex-col group items-center justify-center w-full transition-all duration-150'
											}
										>
											{item.iconLink(
												pathname.includes(item.path) || (hover && hoverIndex === index) ? '#FFFFFF' : 'rgba(255,255,255,0.55)'
											)}
											<p className="flex text-center px-1 text-[11px] font-medium mt-1.5 leading-tight">{t((item as any).titleKey || 'nav.dashboard')}</p>
										</NavLink>
									</Suspense>
								))}
							</div>
						</div>
					</div>
				</div>
				<div
					className=" max-w-112
				 md:flex hidden"
				>
					sasiakhdn
				</div>
				<div className=" h-screen w-full">
					<div
						style={{
							display: pathname.includes(ROUTE_NAMES.settings) ? 'none' : '',
						}}
					>
						<NewHeader handleClick={handleClick} />
					</div>
					<VideoLtdBanner />
					{/* Desktop Banner */}
					<div
						className={
							expiryBanner && checkUserPlan && checkUserPlan?.plan_data?.plan_id === 'dummy_plan'
								? 'top-0 fixed bg-rose-500 flex  justify-between ml-2.5 items-center px-6 md:px-40 h-14 text-white z-50'
								: 'hidden'
						}
						style={{ width: '100%' }}
					>
						<div></div>
						<div className="flex ">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="w-5 mr-1"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								strokeWidth="2"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
								/>
							</svg>
							<p>
								Your current plan is expired.&nbsp;
								<span>
									<button className="underline hover:no-underline" onClick={handleUpgradePlan}>
										Upgrade Plan
									</button>
								</span>
								&nbsp;here.
							</p>
						</div>
						<div>
							<button onClick={() => setExpiryBanner(false)}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="w-5"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									strokeWidth="2"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
							</button>
						</div>
					</div>
					{/* Mobile Banner */}
					<div
						className={
							expiryBanner && checkUserPlan && checkUserPlan?.plan_data?.plan_id === 'dummy_plan'
								? 'top-0 fixed bg-rose-500  hidden w-full  justify-between items-center px-8 h-14 text-white z-40'
								: 'hidden'
						}
					>
						<div className="flex">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="w-5 mr-1"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								strokeWidth="2"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
								/>
							</svg>
							<p>
								Your current plan is expired.&nbsp;
								<span>
									<button className="underline hover:no-underline" onClick={handleUpgradePlan}>
										Upgrade Plan
									</button>
								</span>
								&nbsp;here.
							</p>
						</div>
						<div>
							<button onClick={() => setExpiryBanner(false)}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="w-5"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									strokeWidth="2"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
							</button>
						</div>
					</div>
					<Suspense fallback={<CustomLoader />}>
						<Outlet />
					</Suspense>
				</div>
			</div>
			<NewModal open={selectTemplate} closeIcon={closeIcon} onClose={handleClose} className="w-4/6 bg-white relative">
				<SelectTemplate handleClose={handleClose} />
			</NewModal>
		</>
	);
};

export default LoggedInLayout;
